import { render, staticRenderFns } from "./DialogDocuments.vue?vue&type=template&id=d31a0a3e&scoped=true"
import script from "./DialogDocuments.vue?vue&type=script&lang=js"
export * from "./DialogDocuments.vue?vue&type=script&lang=js"
import style0 from "./DialogDocuments.vue?vue&type=style&index=0&id=d31a0a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31a0a3e",
  null
  
)

export default component.exports